import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuAbout from '../../components/MenuAbout';
// import PostToggler from './PostToggler';
import PostBody from './PostBody';

const styles = css`
  margin-top: 60px;

  .BlogDetail_inner {
    max-width: 1170px;
    margin: 0 auto;
  }
  .BlogDetail_postBody {
    background-color: #FFF;
    padding: 0;

  }
  @media (min-width: 1600px) {
    .BlogDetail_inner {
      max-width: 1280px;
    }
  }
`;

function Blog({ blogpost, page }) {
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader
        h1={get(page, 'meta.name')}
        background={get(page, 'page_image')}
      />
      <MenuAbout />
      <div className={`container ${styles}`}>
        {/* <PostToggler blogposts={blogposts} /> */}
        <div className="BlogDetail_inner d-flex justify-content-center">
          <PostBody className="BlogDetail_postBody col-12 mb-4" blogpost={blogpost} />
        </div>
      </div>
    </PageWrapper>
  );
}

Blog.propTypes = {
  blogpost: PropTypes.object.isRequired,
  // blogposts: PropTypes.arrayOf(PropTypes.object).isRequired,
  page: PropTypes.object.isRequired,
};

export default withData(
  {
    blogpost: true,
    // blogposts: true,
    page: 'blogposts',
  },
  {
    ifMissing404: true,
  },
)(Blog);



// WEBPACK FOOTER //
// ./src/pages/BlogpostDetail/index.js